import React from "react"
import FooterTopGroup from "./FooterTopGroup"
import Link from "../Links"
import IRSEagle from "../Icons/IRSEagle"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faFacebookSquare, faInstagram, faLinkedinIn, faTwitterSquare, faYoutube} from '@fortawesome/free-brands-svg-icons'

 const icons = {
   "facebookIcon": faFacebookSquare,
   "twitterIcon": faTwitterSquare,
   "youtubeIcon": faYoutube,
   "linkin": faLinkedinIn,
   "instagram": faInstagram,
 }

const FooterTop = ({sitemap, socialLinks = [], ...props}) => {

  const sitemapGroup = sitemap.map(({text, list, key}) =>
  <FooterTopGroup key={ key } text={ text }>
    { list.map(({text, href, key, langCode, external}) => 
      <li className="column mb-5 text-black" key={key}>
          <Link
            href={href}  
            external={external}
            langCode={langCode}
            className="hover:underline leading-none"
          >
            {text}
          </Link>
      </li>
    )}
  </FooterTopGroup>
)

  const socialLinksGroup = socialLinks.map(link => {
    return (
      <li key={link.key} className="mr-2">
        <Link tabIndex="0" aria-label={`${link.title} This link will open in a new window.`} href={link.href} external={true} className="block">
          {link.src === "IRSFooterTopIcon" && 
            <IRSEagle alt={link.alt} width="31px" height="27px" focusable='false' className="irs-2go"/>
          }
          {link.src !== "IRSFooterTopIcon" && 
            <FontAwesomeIcon icon={icons[link.src]} alt={link.title} className="social-icons" focusable="false" height="2em" width="2em" />
          }
        </Link>
      </li>
    )
  })

  return (

    <div className="footerTop text-black bg-gray-400 flex-shrink border-t-5 border-black" {...props} role="navigation">
      <div className="menuGroup container pt-5 md:pt-11 pb-2">
        <div className="flex flex-col md:flex-row">
          {sitemapGroup}
        </div>
        <ul className="flex md:justify-end mt-5 md:mt-15 md:-mr-2">
          {socialLinksGroup}
        </ul>
      </div>
    </div>
  )
}

export default FooterTop
